import React, { useState, useRef, useEffect } from "react";
import CardDetail from "./CardDetail";
import DisplayCard from "./DisplayCard";
import PersonalCard from "./PersonalCard";
import InformationCard from "./InformationCard";
import Card1 from "./Card1";
import Card2 from "./Card2";
import Card3 from "./Card3";
import ToastError from "./toasts/ToastError";
import {
  updateCard,
  getAllLookUp,
  uploadImage,
  dataLookUpConst,
  validateDataCard,
} from "../constants";
import {
  straight,
  oval,
  blur,
  facebook_black,
  youtube_black,
  linkedin_black,
  tiktok_black,
  x_black,
  ig_black,
  email_black,
  phone_black,
  wa_black,
  tele_black,
  tokopedia_black,
  shopee_black,
  website_black,
  github_black,
  medium_black,
} from "../assets";
import { useNavigate } from "react-router-dom";

const UpdateCard = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errrorMsg, setErrorMsg] = useState("");
  const [prefix, setPrefix] = useState(data.prefix);
  const [firstName, setFirstName] = useState(data.first_name);
  const [middleName, setMiddleName] = useState(data.middle_name);
  const [lastName, setLastName] = useState(data.last_name);
  const [suffix, setSuffix] = useState(data.suffix);

  const [dataLookup, setDataLookup] = useState(dataLookUpConst);

  const names = [
    { label: "Prefix", value: prefix, funcSet: setPrefix },
    { label: "First name*", value: firstName, funcSet: setFirstName },
    { label: "Middle name", value: middleName, funcSet: setMiddleName },
    { label: "Last name*", value: lastName, funcSet: setLastName },
    { label: "Suffix", value: suffix, funcSet: setSuffix },
  ];

  const [cardName, setCardName] = useState(data.card_name);
  const [cardId, setCardId] = useState(data.slug);
  const [introMsg, setIntroMsg] = useState(data.intro_message);
  const [cardActive, setCardActive] = useState(data.is_active);
  const cardsDetails = [
    { label: "Card Name*", value: cardName, funcSet: setCardName },
    { label: "Card Id*", value: cardId, funcSet: setCardId },
    { label: "Introduction Message", value: introMsg, funcSet: setIntroMsg },
    { label: "Active", value: cardActive, funcSet: setCardActive },
  ];

  const [imageSourceHeader, setImageSourceHeader] = useState(
    data.header_image_url
  );
  const [imageSourceProfile, setImageSourceProfile] = useState(
    data.profile_image_url
  );
  const [imageSourceLogo, setImageSourceLogo] = useState(data.logo_image_url);
  const [jobTitle, setJobTitle] = useState(data.job_title);
  const [company, setCompany] = useState(data.company);
  const [aboutMe, setAboutMe] = useState(data.about_me);
  const onButtonClick = (type) => {
    // `current` points to the mounted file input element
    if (type == "header") {
      inputFile1.current.click();
    } else if (type == "profile") {
      inputFile2.current.click();
    } else {
      inputFile3.current.click();
    }
  };
  const onDeletePhoto = (type) => {
    // `current` points to the mounted file input element
    if (type == "header") {
      setImageSourceHeader(null);
    } else if (type == "profile") {
      setImageSourceProfile(null);
    } else {
      setImageSourceLogo(null);
    }
  };

  const occupations = [
    { label: "Job Title*", value: jobTitle, funcSet: setJobTitle },
    { label: "Company", value: company, funcSet: setCompany },
    { label: "About me", value: aboutMe, funcSet: setAboutMe },
  ];
  const [indexColorTheme, setIndexColorTheme] = useState(
    dataLookup.Display["Color Theme"]
      .map((val, _) => val.lookup_id)
      .indexOf(data.color_theme.id) != -1
      ? dataLookup.Display["Color Theme"]
          .map((val, _) => val.lookup_id)
          .indexOf(data.color_theme.id)
      : 5
  );
  const user = JSON.parse(localStorage.getItem("user_info"));
  const [aspect, setAspect] = useState(1);
  const token = user.access_token;
  const [imageEdit, setImageEdit] = useState(null);
  const [funcSetEdit, setFuncSetEdit] = useState(() => setImageSourceHeader);
  const [informations, setInformations] = useState(
    data.card_social.map((val, ind) => ({
      ...val,
      value_option: val.chosen_value,
      value: val.input_value,
      image_url: val.icon_image_url,
    }))
  );

  const inputFile1 = useRef(null);
  const inputFile2 = useRef(null);
  const inputFile3 = useRef(null);
  const [circularCrop, setCircularCrop] = useState(true);
  const handleOnChangeImage = (event, type) => {
    event.preventDefault();
    let file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    if (type == "header") {
      setFuncSetEdit(() => setImageSourceHeader);
      setAspect(2);
      setCircularCrop(false);
    } else if (type == "profile") {
      setFuncSetEdit(() => setImageSourceProfile);
      setAspect(1);
      setCircularCrop(true);
    } else {
      setFuncSetEdit(() => setImageSourceLogo);
      setAspect(1);
      setCircularCrop(false);
    }
    reader.addEventListener("load", () => {
      const imageUrl = reader.result?.toString() || "";
      setImageEdit(imageUrl);
    });
    reader.readAsDataURL(file);
    document.getElementById("edit_photo_modal").showModal();
  };
  const [colorThemes, setColorThemes] = useState(() => {
    let tempLookup = dataLookup.Display["Color Theme"].map((v, ind) => ({
      color1: "#" + v.values.split(",")[0],
      color2: "#" + v.values.split(",")[1],
      name: v.display_label,
      id: v.lookup_id,
    }));
    if (indexColorTheme == 5) {
      tempLookup.push({
        color1: "#" + data.color_theme_value.split(",")[0],
        color2: "#" + data.color_theme_value.split(",")[1],
        name: "Custom",
      });
    }
    return tempLookup;
  });
  const [colorFirst, setColorFirst] = useState(
    colorThemes[indexColorTheme]
      ? colorThemes[indexColorTheme].color1
      : "#" + data.color_theme_value.split(",")[0]
  );
  const [colorSecond, setColorSecond] = useState(
    colorThemes[indexColorTheme]
      ? colorThemes[indexColorTheme].color2
      : "#" + data.color_theme_value.split(",")[1]
  );
  const [sections, setSections] = useState([
    "Card",
    "Display",
    "Personal",
    "Information",
  ]);
  const [indexTemplate, setIndexTemplate] = useState(
    data.card_template_label == "straight"
      ? 0
      : data.card_template_label == "oval"
      ? 1
      : 2
  );
  const [templates, setTemplates] = useState(
    dataLookup.Display["Card Template"].map((v, i) => ({
      img: v.image_url,
      name: v.display_label,
      id: v.lookup_id,
    }))
  );
  const [activeSection, setActiveSection] = useState(sections[0]);

  const socials = [
    { logo: facebook_black, name: "facebook" },
    { logo: youtube_black, name: "youtube" },
    { logo: linkedin_black, name: "linkedin" },
    { logo: tiktok_black, name: "tiktok" },
    { logo: x_black, name: "x" },
    { logo: ig_black, name: "instagram" },
  ];
  const messagings = [
    { logo: email_black, name: "email" },
    { logo: phone_black, name: "phone" },
    { logo: wa_black, name: "whatsapp" },
    { logo: tele_black, name: "telegram" },
  ];
  const business = [
    { logo: tokopedia_black, name: "tokopedia" },
    { logo: shopee_black, name: "shopee" },
    { logo: website_black, name: "website" },
    { logo: github_black, name: "github" },
    { logo: medium_black, name: "medium" },
  ];

  const Information = {
    Social: socials,
    Messaging: messagings,
    Business: business,
  };

  useEffect(() => {
    if ((colorThemes.length < 6) & (indexColorTheme == 5)) {
      setColorThemes([
        ...colorThemes,
        {
          color1: "#" + data.color_theme_value.split(",")[0],
          color2: "#" + data.color_theme_value.split(",")[1],
          name: "Custom",
        },
      ]);
    }
  }, [colorThemes]);

  const navigate = useNavigate();
  const handleOnClickUpdateCard = async (e) => {
    e.preventDefault();
    setLoading(true);
    let data_ = {
      about_me: aboutMe,
      card_name: cardName,
      card_social: informations.map((val, ind) => ({
        chosen_value: val.value_option,
        display_text: val.display_text ? val.display_text : null,
        input_value: val.value,
        lookup_id: val.lookup_id,
      })),
      card_template_id: templates[indexTemplate].id,
      company: company,
      first_name: firstName,
      intro_message: introMsg,
      is_active: cardActive,
      job_title: jobTitle,
      last_name: lastName,
      middle_name: middleName,
      prefix: prefix,
      slug: cardId,
      suffix: suffix,
    };
    if (indexColorTheme <= 4) {
      data_.color_theme_id = colorThemes[indexColorTheme].id;
    } else {
      data_.color_theme_custom =
        colorFirst.replace("#", "") + "," + colorSecond.replace("#", "");
    }
    if (imageSourceHeader) {
      if (imageSourceHeader.includes("cdn.")) {
        const header_image_id = data.header_image.id;
        data_.header_image_id = header_image_id;
      } else {
        const header_image_id = await uploadImage(
          token,
          imageSourceHeader,
          "card_header"
        );
        data_.header_image_id = header_image_id;
      }
    }

    if (imageSourceProfile) {
      if (imageSourceProfile.includes("cdn.")) {
        const profile_image_id = data.profile_image.id;
        data_.profile_image_id = profile_image_id;
      } else {
        const profile_image_id = await uploadImage(
          token,
          imageSourceProfile,
          "card_profile"
        );
        data_.profile_image_id = profile_image_id;
      }
    }

    if (imageSourceLogo) {
      if (imageSourceLogo.includes("cdn.")) {
        const logo_image_id = data.logo_image.id;
        data_.logo_image_id = logo_image_id;
      } else {
        const logo_image_id = await uploadImage(
          token,
          imageSourceLogo,
          "card_logo"
        );
        data_.logo_image_id = logo_image_id;
      }
    }
    let err = validateDataCard(data_);
    if (err != "") {
      setErrorMsg(err);
      setShowError(true);
      setLoading(false);
      return;
    }
    updateCard(
      token,
      data_,
      data.card_id,
      setLoading,
      setShowError,
      setErrorMsg,
      navigate
    );
  };

  useEffect(() => {
    getAllLookUp(token, setColorThemes, setTemplates, setDataLookup);
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [showError]);

  return (
    <div className="flex flex-col md:flex-row w-full bg-white h-full overflow-y-auto md:overflow-y-hidden">
      {showError ? <ToastError error={errrorMsg} /> : null}
      <div className="flex flex-col border-0 border-r-2 border-r-gray-200 w-full md:w-1/2 px-7 py-5 gap-3 items-center md:overflow-y-hidden">
        {indexTemplate == 0 ? (
          <Card1
            colorFirst={colorFirst}
            colorSecond={colorSecond}
            imageSourceHeader={imageSourceHeader}
            imageSourceLogo={imageSourceLogo}
            imageSourceProfile={imageSourceProfile}
            prefix={prefix}
            suffix={suffix}
            firstName={firstName}
            middleName={middleName}
            lastName={lastName}
            jobTitle={jobTitle}
            company={company}
            aboutMe={aboutMe}
            informations={informations}
          />
        ) : indexTemplate == 1 ? (
          <Card2
            colorFirst={colorFirst}
            colorSecond={colorSecond}
            imageSourceHeader={imageSourceHeader}
            imageSourceLogo={imageSourceLogo}
            imageSourceProfile={imageSourceProfile}
            prefix={prefix}
            suffix={suffix}
            firstName={firstName}
            middleName={middleName}
            lastName={lastName}
            jobTitle={jobTitle}
            company={company}
            aboutMe={aboutMe}
            informations={informations}
          />
        ) : (
          <Card3
            colorFirst={colorFirst}
            colorSecond={colorSecond}
            imageSourceHeader={imageSourceHeader}
            imageSourceLogo={imageSourceLogo}
            imageSourceProfile={imageSourceProfile}
            prefix={prefix}
            suffix={suffix}
            firstName={firstName}
            middleName={middleName}
            lastName={lastName}
            jobTitle={jobTitle}
            company={company}
            aboutMe={aboutMe}
            informations={informations}
          />
        )}

        <div
          className="px-10 py-2 bg-primary text-white shadow-lg hover:bg-tertiary active:translate-y-1 cursor-pointer rounded-lg"
          onClick={handleOnClickUpdateCard}
        >
          {loading ? (
            <div role="status">
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="white"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="#E47410"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Update Card"
          )}
        </div>
      </div>
      <div className="flex flex-col w-full h-full divide-y-[1px] divide-gray-200 ">
        <div className="flex flex-row w-full">
          {sections.map((v, i) => (
            <div
              className={`px-5 py-4 cursor-pointer hover:font-bold ${
                activeSection == v ? "font-bold hover:text-secondary" : ""
              }`}
              key={i}
              onClick={() => setActiveSection(v)}
            >
              {v}
            </div>
          ))}
        </div>
        <div className="flex flex-col w-full justify-start items-start overflow-y-auto h-[74vh]">
          {activeSection == "Card" ? (
            <CardDetail cardsDetails={cardsDetails} isDisabled={true} />
          ) : activeSection == "Display" ? (
            <DisplayCard
              templates={templates}
              indexTemplate={indexTemplate}
              setIndexTemplate={setIndexTemplate}
              colorThemes={colorThemes}
              setColorThemes={setColorThemes}
              setColorSecond={setColorSecond}
              setColorFirst={setColorFirst}
              inputFile1={inputFile1}
              inputFile2={inputFile2}
              inputFile3={inputFile3}
              handleOnChangeImage={handleOnChangeImage}
              onButtonClick={onButtonClick}
              onDeletePhoto={onDeletePhoto}
              imageSourceHeader={imageSourceHeader}
              imageSourceProfile={imageSourceProfile}
              setImageSourceProfile={setImageSourceProfile}
              imageSourceLogo={imageSourceLogo}
              indexColorTheme={indexColorTheme}
              setIndexColorTheme={setIndexColorTheme}
              imageEdit={imageEdit}
              funcSetEdit={funcSetEdit}
              aspect={aspect}
              circularCrop={circularCrop}
            />
          ) : activeSection == "Personal" ? (
            <PersonalCard names={names} occupations={occupations} />
          ) : (
            <InformationCard
              informations={informations}
              setInformations={setInformations}
              Information={dataLookup.Information}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateCard;
